import { Brand } from './Brand';

export const getBaseUrlForBrand = (brand: Brand): URL =>
    new URL((brand === 'star' ? process.env.NEXT_PUBLIC_STAR_APP_URL : process.env.NEXT_PUBLIC_APP_URL) as string);
